export function formLink(formId: string) {
    return `${process.env.REACT_APP_HOST}/fill/${formId}`;
}

export function groupLink(groupId: string) {
    return `${process.env.REACT_APP_HOST}/fillgroup/${groupId}`;
}